import FixtureTeamLogo from "./FixtureTeamLogo";
import FixtureStatus from "./FixtureStatus";
import FixtureTeamName from "./FixtureTeamName";
import FixtureLiveStatus from "./FixtureLiveStatus";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    paddingTop: 3,
    paddingBottom: 3,
  },
  fixtureContainer: {
    textDecoration: "none",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
};

const Fixture = (props) => {
  const { fixture, teams, goals, penalty } = props;

  return (
    <div style={styles.container}>
      <div style={styles.fixtureContainer}>
        <FixtureTeamName
          atHome={true}
          name={teams.home.name}
          code={teams.home.code}
        />
        <FixtureTeamLogo logo={teams.home.logo} />
        <FixtureStatus
          status={fixture.status}
          date={fixture.date}
          goals={goals}
        />
        <FixtureTeamLogo logo={teams.away.logo} />
        <FixtureTeamName name={teams.away.name} code={teams.away.code} />
      </div>
      <FixtureLiveStatus status={fixture.status} penalty={penalty} />
    </div>
  );
};

export default Fixture;
